function safeDecode(value: string): string {
  try {
    return decodeURIComponent(value);
  } catch {
    // Malformed percent-encoding (e.g. "%GG") — use raw value
    return value;
  }
}

function truncateMiddle(value: string, maxLength: number): string {
  if (value.length <= maxLength) return value;
  const chunk = Math.floor(maxLength / 2);
  return `${value.slice(0, chunk - 1)}…${value.slice(value.length - chunk)}`;
}

export default function getFileNameFromUrl(
  url: string | null | undefined,
  maxLength?: number
): string | null {
  if (!url) return null;

  const urlString = /https?:\/\//i.test(url)
    ? url
    : `http://example.com/${url.replace(/^\//, '')}`;

  let lastSegment: string | undefined;
  try {
    lastSegment = new URL(urlString).pathname.split('/').at(-1);
  } catch {
    return null;
  }
  if (!lastSegment) return null;

  const decoded = safeDecode(lastSegment);
  return maxLength ? truncateMiddle(decoded, maxLength) : decoded;
}
